import React, { useState } from "react";
import { Nav, NavItem, NavLink, Row, Col } from "reactstrap";
import Overview from "./Overview"; // Import the new component

import MyStockPlant from '../../../CandidateAndCompany/ProcessingPlant/processingplantStockAccept';
import CourierApproval from '../../../CandidateAndCompany/Courier/CourierAccept';
import ProcessingCost from '../../../CandidateAndCompany/ProcessingPlant/AddProcessingCost';
import CourierMap from './courierMap';




import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faServer,
  faShoppingBag,
  faGear,
  faPlusSquare,
} from '@fortawesome/free-solid-svg-icons';

const DashboardContent = () => {
  const [activeTab, setActiveTab] = useState('overview');

  const renderActivePage = () => {
    switch (activeTab) {
      case 'overview':
        return <Overview />;

    

      case 'courierMap':
        return <CourierMap />;

      

      case 'CourierApproval':
        return <CourierApproval />;

    

   
      // Add more cases if you have other pages to load
   
      default:
        return <Overview />;
    }
  };

  return (
    <Row className="g-4">
      <Col
        md={12}
        lg={2}
        style={{
          background: 'white',
          borderRadius: '20px',
          boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        }}
      >
        <ul
          id="menu-ul"
          style={{ paddingLeft: '10px' }}
        >
          <li
            style={{
              color: activeTab === 'overview' ? '#044B92' : '#000',
              backgroundColor: activeTab === 'overview' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('overview')}
          >
            <FontAwesomeIcon
              icon={faTachometerAlt}
              style={{ marginRight: '10px' }}
            />
            {'  '} Dashboard
          </li>

         

          {/* <li
            style={{
              color: activeTab === 'ProcessingApproval' ? '#044B92' : '#000',
              backgroundColor:
                activeTab === 'ProcessingApproval' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('ProcessingApproval')}
          >
            <FontAwesomeIcon
              icon={faServer}
              style={{ marginRight: '10px' }}
            />
            {'  '} Processing Approval
          </li> */}
          {/* <li
            style={{
              color: activeTab === 'ProcessingCost' ? '#044B92' : '#000',
              backgroundColor:
                activeTab === 'ProcessingCost' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('ProcessingCost')}
          >
            <FontAwesomeIcon
              icon={faServer}
              style={{ marginRight: '10px' }}
            />
            {'  '} Processing Cost
          </li> */}

          <li
            style={{
              color: activeTab === 'CourierApproval' ? '#044B92' : '#000',
              backgroundColor:
                activeTab === 'CourierApproval' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('CourierApproval')}
          >
            <FontAwesomeIcon
              icon={faServer}
              style={{ marginRight: '10px' }}
            />
            {'  '} Courier Approval
          </li>

          <li
            style={{
              color: activeTab === 'courierMap' ? '#044B92' : '#000',
              backgroundColor:
                activeTab === 'courierMap' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('courierMap')}
          >
            <FontAwesomeIcon
              icon={faServer}
              style={{ marginRight: '10px' }}
            />
            {'  '} Map
          </li>

          {/* <li
            style={{
              color: activeTab === 'Orders' ? '#044B92' : '#000',
              backgroundColor: activeTab === 'Orders' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            onClick={() => setActiveTab('Orders')}
          >
            <FontAwesomeIcon
              icon={faShoppingBag}
              style={{ marginRight: '10px' }}
            />
            {'  '} My Orders
          </li> */}

          {/* <li
            style={{
              color: activeTab === 'Settings' ? '#044B92' : '#000',
              backgroundColor: activeTab === 'Settings' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('Settings')}
          >
            <FontAwesomeIcon
              icon={faGear}
              style={{ marginRight: '10px' }}
            />
            {'  '} Settings
          </li> */}

          {/* <li
            style={{
              color: activeTab === 'Cof Requests' ? '#044B92' : '#000',
              backgroundColor:
                activeTab === 'Cof Requests' ? '#D8E6FA' : '#fff',
              borderRadius: '20px',
              transition: 'all 0.3s ease-in-out', // Add smooth transition
            }}
            href="#"
            onClick={() => setActiveTab('Cof Requests')}
          >
            <FontAwesomeIcon
              icon={faPlusSquare}
              style={{ marginRight: '10px' }}
            />
            {'  '} Cof Requests
          </li> */}
        </ul>
      </Col>
      <Col
        md={12}
        lg={10}
      >
        {renderActivePage()}
      </Col>
    </Row>
  );
};

export default DashboardContent;
